export const borderTypes=[
    ["none","Ninguno"],
    ["dotted","Dotted"],
    ["dashed","Dashed"],
    ["solid","Solid"],
    ["groove","Groove"],
    ["ridge","Ridge"],
    ["inset","Inset"],
    
]